// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__twoCols--m5mZB {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
}
.src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__vert--eaYDa {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__valueRow--_PGuK {
  display: flex;
  gap: 8px;
}
.src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__sortOrderLabel--Dcbk6 {
  display: flex;
  gap: 8px;
  align-items: center;
}
.src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__sortOrderLabel--Dcbk6 span {
  color: #737373;
}
.src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__sortOrder--fGQAX {
  flex: 0 0 120px;
}
.src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__value--zfpfP {
  flex: 1 1 auto;
}
.src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__valueCol--TqLbt {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ManagementPage/Dict2Tab/AttrFields2/AttrFields2.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AACF;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAAF;AAGA;EACE,aAAA;EACA,QAAA;AADF;AAIA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AAFF;AAIE;EACE,cAAA;AAFJ;AAMA;EACE,eAAA;AAJF;AAOA;EACE,cAAA;AALF;AAQA;EACE,aAAA;EACA,OAAA;EACA,sBAAA;EACA,QAAA;AANF","sourcesContent":[".twoCols {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 24px;\n}\n\n.vert {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.valueRow {\n  display: flex;\n  gap: 8px;\n}\n\n.sortOrderLabel {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n\n  & span {\n    color: #737373;\n  }\n}\n\n.sortOrder {\n  flex: 0 0 120px;\n}\n\n.value {\n  flex: 1 1 auto;\n}\n\n.valueCol {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"twoCols": `src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__twoCols--m5mZB`,
	"vert": `src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__vert--eaYDa`,
	"valueRow": `src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__valueRow--_PGuK`,
	"sortOrderLabel": `src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__sortOrderLabel--Dcbk6`,
	"sortOrder": `src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__sortOrder--fGQAX`,
	"value": `src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__value--zfpfP`,
	"valueCol": `src-pages-ManagementPage-Dict2Tab-AttrFields2-AttrFields2-module__valueCol--TqLbt`
};
export default ___CSS_LOADER_EXPORT___;
